import { IonBadge } from "@ionic/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Utils from "../utils/utils";
import PropertyListItemMonths from "./PropertyListItemMonths";

function PropertyListItemRentingDetails({ elem, data }: any) {
	const { t } = useTranslation();
	const current = data?.current;
	const future = data?.future || false;
	const nextRendingDate = current?.end;
	const overdue = data?.months
		.filter((k: any) => k.clear === false)
		.reduce((acc: number, k: any) => acc + parseFloat(k.remaining), 0);

	if (!elem) return <></>;

	if (elem?.status === "vacant")
		return <IonBadge color="danger">{t("vacant")}</IonBadge>;

	if (elem?.status === "occupied" && data && current)
		return (
			<>
				<IonBadge color="primary">{t("occupied")}</IonBadge>
				<br />
				{current?.clear === false && (
					<>
						<IonBadge color="danger">{t("notPaid")}</IonBadge>{" "}
						<IonBadge color="danger">
							{t("currencySymbol")}
							{Utils.formatToCurrency(
								current?.amount || 0
							)} / {Utils.formatToCurrency(current?.rent || 0)}
						</IonBadge>
						<br />
					</>
				)}
				{current?.clear === true && (
					<>
						<IonBadge color="primary">{t("paid")}</IonBadge>
						<br />
					</>
				)}
				{overdue > 0 && (
					<>
						<IonBadge color="danger">
							{
								data?.months.filter(
									(k: any) => k.clear === false
								).length
							}{" "}
							{t("overdueRent")}
						</IonBadge>
						<br />
					</>
				)}
				{t("rentingStarted")}:{" "}
				{elem?.rentingDate
					? moment(elem?.rentingDate).format("DD MMM YYYY")
					: "--"}{" "}
				<br />
				{t("nextRentingDate")}:{" "}
				{moment(nextRendingDate).format("DD MMM YYYY")}
				<PropertyListItemMonths months={data?.months} future={future} />
			</>
		);

	return <></>;
}

export default PropertyListItemRentingDetails;
